export default function (text, type = "") {
    return (/[\u0590-\u05FF]/).test(text) || type === "he";
}
